export type LockTime = {
  period: number
  multiplier: number
}

export enum Flow {
  BITCOIN = "bitcoin",
  ETHEREUM = "ethereum",
}

export type PortalToken<T> = {
  token: T
  icon: string
  invertColorOnHover?: boolean
}

export type DepositInputError = "funds" | "minimum-btc" | null

// TODO: This might be moved somewhere else (maybe mezo-sdk?) once we know for
// for sure what will be returned from the backend.
export type DailyBoostMats = {
  token: string
  value: number
}

export enum DepositMigrationStatus {
  NotEligible,
  NotInitiated,
  InProgress,
  Completed,
}
